import markdownToSemanticHtml from './markdown_to_semantic_html';

// Native messages have no browser DOM. Serialize the same Markdown source
// into semantic, resource-free HTML for AppKit's rich-text pasteboard flavor.
export default function getMessageHtmlForCopy(messageId, markdown, options) {
  return markdownToSemanticHtml(markdown, options) || undefined;
}
